import { IUserDataToken } from 'utils/types';
import { useEffect, useState } from 'react';
import { useQuery } from '@apollo/client';
import { QUERY_ME } from 'graphql/mutations/auth';

const useMyRole = () => {
    const { data: curUserData } = useQuery(QUERY_ME);
    const tenantId = localStorage.getItem('tenant_id');
    const [role, setRole] = useState<number | null>(null);

    useEffect(() => {
        if (!tenantId || !curUserData?.me) return;
        const userData: IUserDataToken = JSON.parse(curUserData.me);
        const myTenantData = userData.tenants.find((tenant) => tenant.tenantId === Number(tenantId));
        if (myTenantData) setRole(Number(myTenantData.role) || null);
    }, [tenantId, curUserData]);

    return role;
};

export default useMyRole;
